// extracted by mini-css-extract-plugin
module.exports = {"main":"NoSidebarLayout_main__qaj3n"};